/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import PaymentProvider from 'DesignSystem/PaymentProvider/index'
import React from 'react'
import TreatmentPayments from './TreatmentPayments/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content"
  
}) {
let globalCurrentLocationXidValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location.xid',
})
  return (<React.Fragment
>
<PaymentProvider
  viewPath={`${viewPath}/PaymentProvider`}
 allowLocationChoice={true}
 data="global.current_location.xid"
 xid={globalCurrentLocationXidValueData}
 viewPath={viewPath}
>
{childProps => (
<TreatmentPayments
{...childProps}
  viewPath={`${viewPath}/TreatmentPayments`}
/>
)}
</PaymentProvider>
{children}
</React.Fragment>)
}